import { render, staticRenderFns } from "./SumTesting.vue?vue&type=template&id=74c63628&scoped=true"
import script from "./SumTesting.vue?vue&type=script&lang=js"
export * from "./SumTesting.vue?vue&type=script&lang=js"
import style0 from "./SumTesting.vue?vue&type=style&index=0&id=74c63628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c63628",
  null
  
)

export default component.exports